import decorationStar from "../assets/statement/decoration-star.svg";
import { FaCheck } from "react-icons/fa";

const Statement = () => {
  return (
    <>
      <section
        id="details"
        className="details position-relative overflow-hidden"
        style={{
          marginTop: "12rem",
          marginRight: "calc(-50vw + 50%)",
          marginLeft: "calc(-50vw + 50%)",
          width: "100vw",
        }}
      >
        <img
          src={decorationStar}
          alt=""
          className="decoration-star position-absolute"
        />
        <div className="container position-relative z-3">
          <div className="row align-items-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="image-container d-flex justify-content-center">
                <video
                  src="/videos/hoshvim-plus-video.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls
                  className="img-fluid"
                  style={{ borderRadius: "8px" }}
                />
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="mt-4">
                <h2 className="mb-4 text-end">
                  <span style={{ color: "#7F57A4" }}>?למה חושבים פלוס</span>
                </h2>
                <ul className="list-unstyled">
                  <li className="d-flex align-items-start justify-content-end mb-3">
                    <p className="text-end mx-4">
                      ילדים חושבים ושמחים, המאתגרים עצמם בחשיבה ועובדים בשיתוף
                      פעולה - זה החזון שלנו ולאורו אנו פועלים
                    </p>
                    <div>
                      <FaCheck size="1.5rem" color="#7F57A4" />
                    </div>
                  </li>
                  <li className="d-flex align-items-start justify-content-end mb-3">
                    <p className="text-end mx-4">
                      ערך עליון עבורנו להטמיע את הלמידה במגוון דרכים יצירתיות
                      ומהנות לפיתוח מיומנויות החשיבה והאסטרטגיה אצל ילדים,
                      במיוחד בעידן של היום
                    </p>
                    <div>
                      <FaCheck size="1.5rem" color="#7F57A4" />
                    </div>
                  </li>
                  <li className="d-flex align-items-start justify-content-end mb-3">
                    <p className="text-end mx-4">
                      חרטנו על דגלנו שירות מצוין, אמינות, רצינות, בקרת איכות
                      ויחס אישי, תוך הקפדה על חומרים איכותיים ופרקטיים בהתאם
                      לשימוש
                    </p>
                    <div>
                      <FaCheck size="1.5rem" color="#7F57A4" />
                    </div>
                  </li>
                  <li className="d-flex align-items-start justify-content-end mb-3">
                    <p className="text-end mx-4">
                      אנו פועלים מתוך אמונה כי עלינו להתאים עצמנו לצרכי הלקוח,
                      תוך דיוק ושיתוף פעולה פורה
                    </p>
                    <div>
                      <FaCheck size="1.5rem" color="#7F57A4" />
                    </div>
                  </li>
                  <li className="d-flex align-items-start justify-content-end mb-3">
                    <p className="text-end mx-4">
                      חושבים פלוס מורכב מצוות חינוכי, מקצועי, בעל ניסיון רב
                      בניהול ופיקוד בפיתוח והובלת תוכניות חינוכיות ותוכניות
                      העשרה בבתי ספר ובצבא
                    </p>
                    <div>
                      <FaCheck size="1.5rem" color="#7F57A4" />
                    </div>
                  </li>
                  <li className="d-flex align-items-start justify-content-end mb-3">
                    <p className="text-end mx-4">
                      רכשתם ערכת חושבים פלוס? זמינים בכל שעה להדרכה, באם תידרש
                    </p>
                    <div>
                      <FaCheck size="1.5rem" color="#7F57A4" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Statement;

// const Statement = () => {
//   return (
//     <>
//       <section className="statement mb-5" style={{ marginTop: "5rem" }}>
//         <div className="container">
//           <div className="row">
//             <div className="col-12">
//               <div className="text-container bg-light p-5 rounded-5">
//                 <h1 className="text-center alef-style">?למה בינה ודעת</h1>
//                 <p className=" mt-3 text-end">
//                   חרטנו על דגלנו שירות מעולה, יחס נעים והתאמה אישית לצרכים
//                   ולמטרות שלכם. חשוב לנו שכל לקוח יצא עם חיוך ועם המוצר שמתאים
//                   לו ביותר.
//                   <br />
//                   ילדים מאושרים זה הכיף שלנו, יושר ואמינות גם הן מילות מפתח
//                   אצלנו (ולכן לעולם לא נמליץ לכם על מוצר לא מתאים וגם לא נדחף מה
//                   שלא רלוונטי) חשוב לנו מאד לגוון ולכן אתגר וחוויה היא אטרקציה
//                   אמיתית לכל הילדים ולכל אלו שהם ילדים בנשמתם. קיים מגוון עשיר
//                   של מותגים במנעד שונה של מחירים ואיכויות, ובהתאמה לכל כיס. גם
//                   המבצעים המשתלמים והמתחלפים תורמים לחוויית קניה מושלמת. רכשתם
//                   משחק חשיבה? אין מצב שהוא ישכב סתם בארון… ב"אתגר וחוויה" תקבלו
//                   הדרכה מקצועית בגובה העיניים איך משחקים במשחק כדי שתוכלו למקסם
//                   את ההנאה ואת חווית השימוש במוצר. אנחנו כאן בשבילכם גם אחרי
//                   הקניה, חשוב לנו שתהיו מרוצים ותהנו לאורך זמן ובדיוק מהסיבה הזו
//                   אנו מציעים שירות ייחודי ומדליק- חלקי חילוף מקוריים לבימבות,
//                   טרמפולינות וכד', זו הדרך שלנו להבטיח לכם חווית שימוש ארוכת
//                   טווח, ומכל הלב. אלפי לקוחותינו חוזרים שוב ושוב וזו הבעת האמון
//                   המרגשת ביותר. כי כשהמגוון ענק, הזמינות גבוהה ומאחורי הקופה יש
//                   לב, אכפתיות והתאמה אישית- זה בעצם שם המשחק.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       ;
//     </>
//   );
// };

// export default Statement;
